<template>
  <div class="clearerApp" :style="'min-height:'+curHeight+'px'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="数据加载中" element-loading-background="rgba(0, 0, 0, 0)" element-loading-spinner="el-icon-loading">
    <div class="meheader">
      <div class="headMe">
        <img :src="userData.avatar" />
        <div class="right">
          <h2>{{userData.username}}</h2>
          <p>加入时间:{{userData.createtime}}</p>
        </div>
      </div>

      <ul>
        <li>
          <h3>{{t.total}}</h3>
          <div>总收入</div>
        </li>
        <li>
          <h3>{{detail.length}}</h3>
          <div>订单总数</div>
        </li>
        <li>
          <h3>{{t.dtTotail}}</h3>
          <div>当天订单</div>
        </li>
        <li>
          <h3>{{t.dclTotail}}</h3>
          <div>待处理订单</div>
        </li>
      </ul>
    </div>
    <div class="h2">咖啡机设备订单<span @click="$router.push('mwallet')">去提现<i class="el-icon-arrow-right"></i></span></div>
    <div class="pro" v-for="(item,i) in detail">
      <div class="bussTitle">
        <el-image style="width:50px;height:50px; border-radius:5px;float:left" :src="baseUrl+item.images" fit="cover"></el-image>
        <div class="name">
          <p>{{item.title}}</p>
          <p>地址：{{item.address}}</p>
        </div>
        <div class="status" :style="item.status == 1 ? 'color:red' : item.status == 2 ? 'color:green' : 'color:#ccc'">{{item.status == 1 ? '补充配料' : (item.status == 2 ? '已完成':item.status == 3 ? '审核中' : '未通过')}}</div>
      </div>
      <div class="email">
        生成时间 <span>{{item.createtime}}</span>
      </div>
      <div class="email">
        备注说明 <span v-if="item.status != 2">{{item.types == 1 ? '系统检查设备缺奶配料' : '系统检查设备缺咖啡豆配料'}}</span>
        <span v-if="item.status == 2">恭喜您，补货完成</span>
      </div>
      <div class="email" style="color:#fff;border-bottom:none">.
        <a @click="goClearer(item.id)" v-if="item.status == 1 || item.status == 4">去补货<font class="el-icon-arrow-right"></font></a>
        <span class="curt">{{item.status == 1 ? '提成：￥'+item.cprice+'元' : '收益：￥'+item.cprice+'元'}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        userData:[],
        curHeight:0,
        fullscreenLoading: false,
        baseUrl:'',
        detail:[],
        t:[],
        code:''
      };
    },
    created(){
      
      if(localStorage.getItem('userjwt') == null){
        var code = this.codefun('code');
        if(!code){
          var id = this.$route.query.id;
          var url = encodeURIComponent('http://user.4008005216.com/main/goclearer?id='+id);
          window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa89a20966e69c2a5&redirect_uri="+url+"&response_type=code&scope=snsapi_userinfo&state=STATE";
          return;
        }else{
          this.code = code;
        }
      }else{
        this.userData = localStorage.getItem('userjwt') == null ? [] : JSON.parse(localStorage.getItem('userjwt'));
      }
    },
    beforeMount() {
      this.baseUrl = this.$host;
      document.addEventListener('WeixinJSBridgeReady', function onBridgeReady() {
        WeixinJSBridge.call('hideAllNonBaseMenuItem');
        WeixinJSBridge.call('hideOptionMenu');
      });
    },
    mounted() {
      this.beforeMount();
      this.getDetail()
      this.getTotal()
    },

    methods: {
      beforeMount:function(){
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.curHeight =h; //减去页面上固定高度height
      },

      goClearer:function(id){
        window.location.href="http://user.4008005216.com/main/goclearer?id="+id
      },
      getDetail:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/clearerList',
          params:{
            id:id,
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.detail = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },

      getTotal:function(e){
        var that = this;
        var id = this.$route.query.id;
        this.axios({
          method:'post',
          url:that.$host+'home/crowd/clearerTotal',
          params:{
            user_id:that.userData.id
          }
        }).then(function(response){
          var res = response.data;
          that.t = res.data;
          that.fullscreenLoading = false;
        }).catch(err=>{
          console.log('请求失败:'+err);
        });
      },
      login:function(){
        var that = this;
        that.axios({
          method:'post',
          url:that.$host+'home/user/login',
          params:{
            code:that.code
          }
        }).then(function(response){
          var res = response.data;
          that.userData = res.data;
          localStorage.setItem('userjwt', JSON.stringify(res.data));
          that.getDetail()
          that.getTotal()
        }).catch(err=>{

        });
      },
      codefun:function(name) {
        let reg = new RegExp("(\\?|&)" + name + "=([^&]*)(&|$)", "i");
        let r = window.location.search.match(reg);
        if (r != null) return unescape(r[2]);
        return false;
      },
    },
  };
</script>

<style>
  .el-loading-spinner{
    width:30%;
    background:rgba(0,0,0,0.8);
    left:50%;
    transform: translateX(-50%);
    border-radius:5px;
    padding:15px 0;
    color:#fff;
  }
  .el-loading-spinner i{
    color:#fff;
    font-size:22px
  }
  .el-loading-spinner .el-loading-text{
    color:#fff;
  }
  .el-message-box{
    width:70%
  }
  .clearerApp{
    background:#ececec;
    max-width:640px;
    margin:0 auto;
  }

  .clearerApp .meheader{
    background: linear-gradient(90deg, #61BEFF, #4F7CFF);
  }
  .clearerApp .headMe{
    width:92%;
    margin:0 auto;
    padding:15px 0;
  }
  .clearerApp .headMe:after,.clearerApp ul:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .clearerApp .headMe img{
    width:60px;
    border-radius:100%;
    float:left;
  }
  .clearerApp .headMe .right{
    float:left;
    width:75%;
    margin-left:3%;
  }
  .clearerApp .headMe .right h2{
    font-size:18px;
    padding:7px 0 5px 0;
    color:#fff
  }
  .clearerApp .headMe .right h2 input{
    font-weight:normal;
    font-size:12px;
    color:#FF6600;
    border:none;
    width:65px;
    background:none;
    outline:none;
  }
  .clearerApp .headMe .right p{
    font-size:15px;
    color:#555;
    color:#fff
  }
  .clearerApp ul{
    clear:both;
    padding:0px 0 20px 0;
    width:100%
  }
  .clearerApp ul li{
    float:left;
    width:25%;
    position:relative;
  }
  .clearerApp ul li:after{
    position:absolute;
    content:'';
    width:1px;
    height:30px;
    background:#61BEFF;
    right:0;
    top:50%;
    transform: translateY(-50%);
  }
  .clearerApp ul li:last-child:after{
    background:#4F7CFF;
  }
  .clearerApp ul li h3{
    text-align:center;
    font-size:20px;
    color:#fff
  }
  .clearerApp ul li div{
    text-align:center;
    font-size:14px;
    color:#666;
    padding-top:3px;
    color:#fff
  }
  .clearerApp .h2{
    padding:15px 0;
    color:#000;
    font-size: 16px;
    border-bottom: solid 1px #f5f5f5;
    background:#fff;
    position: relative;
    padding-left:7%;
    font-weight:bold;
  }
  .clearerApp .h2 span{
    float:right;
    font-size:14px;
    margin-right:2%;
    font-weight:normal;
    color:#666
  }
  .clearerApp .h2:after {
    content: '';
    width: 3px;
    height: 15px;
    background: #141EF1;
    position: absolute;
    left: 4%;
    top: 19px;
    border-radius: 3px;
  }

  .clearerApp .pro{
    background:#fff;
    display:block;
    width:100%;
    margin:0 auto 15px auto;
  }
  .clearerApp .pro .goods:after,.clearerApp .pro .bussTitle:after,.clearerApp .email:after{
    display:block;clear:both;content:"";visibility:hidden;height:0
  }
  .clearerApp .pro .bussTitle{
    width:92%;
    margin:0 auto;
    padding:10px 0
  }
  .clearerApp .pro .bussTitle img{
    width:50px;
    border-radius:5px;
    float:left;
  }
  .clearerApp .pro .bussTitle .name{
    float:left;
    width:68%;
    margin-left:2%
  }
  .clearerApp .pro .bussTitle .name p{
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    font-weight:bold
  }
  .clearerApp .pro .bussTitle .name p:last-child{
    font-size:12px;
    padding-top:10px;
    color:#999;
    font-weight:normal
  }
  .clearerApp .pro .bussTitle .status{
    float:right;
    font-size:12px;
    color:#666;
    margin-top:12px;
    font-weight:bold;
  }

  .clearerApp .goods{
    background:#f5f5f5;
    width:92%;
    margin:0 auto 1px auto;
  }
  .clearerApp .goods .left{
    float:left;
    width:16%;
    border-radius:5px;
    margin:4% 2% 2% 4%;
  }
  .clearerApp .goods .right{
    float:left;
    margin-top:4%;
    width:73%;
    position: relative;
    min-height:60px;
  }
  .clearerApp .goods .right p{
    letter-spacing:1px;
    font-size:15px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#000;
    width:78%
  }
  .clearerApp .goods .right .num{
    font-size: 13px;
    color: #999999;
    padding-top:13px;
  }
  .clearerApp .goods .right .price{
    color:#f00;
    font-size:15px;
    position: absolute;
    top:0;
    right:0;
    text-align:right
  }
  .clearerApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }
  .clearerApp .goods .right .price b{
    color: #f00;
    font-size:18px;
    font-weight:600;
  }

  .clearerApp .goods .right .price i{
    color: #f00;
    font-size:13px;
    font-style:normal
  }
  
  .clearerApp .goods .right .price font{
    color:#666;
    font-size:14px;
    padding-left:8px
  }
  .clearerApp .goods .right .price div{
    font-size:12px;
    color:#999;
    text-decoration: line-through;
  }

  .clearerApp .email{
    background:#fff;
    height:50px;
    line-height:50px;
    font-size:15px;
    color:#333;
    display:block;
    padding-left:4%;
    margin:0 auto;
    border-bottom:solid 1px #f5f5f5;
  }
  .clearerApp .email span{
    color:#666;
    font-size: 15px;
    float:right;
    font-weight:normal;
    margin-right:4%
  }
  .clearerApp .email span.curt{
    color:#f00;
    font-size:15px;
  }
  .clearerApp .email a{
    float:right;
    color:rgba(0,74,224,.7);
    margin-right:4%;
    font-size:15px;
    padding-left:10px;
    font-weight:bold
  }
</style>